
import {throwError as observableThrowError, of as observableOf,  Observable } from 'rxjs';

import {tap, map, catchError, switchMap} from 'rxjs/operators';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Injectable, Optional, Inject, Injector } from '@angular/core';

import { Http, Response, Headers } from '@angular/http';
import { ConfigService } from '../../@core/config/config.service';

//import 'rxjs-compat/add/operator/map';


//import 'rxjs-compat/add/operator/map';

import { NbAbstractAuthProvider } from './providers/abstract-auth.provider';
import { NbAuthSimpleToken, NbTokenService } from './token.service';
import { NB_AUTH_PROVIDERS_TOKEN } from './auth.options';
import {
  NbDummyAuthProvider,
} from './dummy-auth.provider';
import { User} from '../../@core/models/user.entity';
import { errorMessage } from '../../@core/utils/errorMessage.model';

export class NbAuthResult {

  protected token: any;
  protected errors: string[] = [];
  protected messages: string[] = [];

  // TODO pass arguments in options object
  constructor(protected success: boolean,
    protected response?: any,
    protected redirect?: any,
    errors?: any,
    messages?: any,
    token?: NbAuthSimpleToken,
    ) {

    this.errors = this.errors.concat([errors]);
    if (errors instanceof Array) {
      this.errors = errors;
    }

    this.messages = this.messages.concat([messages]);
    if (messages instanceof Array) {
      this.messages = messages;
    }

    this.token = token;
  }

  getResponse(): any {
    return this.response;
  }

  getTokenValue(): any {
    return this.token;
  }

  replaceToken(token: NbAuthSimpleToken): any {
    this.token = token
  }

  getRedirect(): any {
    return this.redirect;
  }

  getErrors(): string[] {
    return this.errors.filter(val => !!val);
  }

  getMessages(): string[] {
    return this.messages.filter(val => !!val);
  }

  isSuccess(): boolean {
    return this.success;
  }

  isFailure(): boolean {
    return !this.success;
  }
}

@Injectable()
export class NbAuthService {
  //providers = {}

  private baseUrl;

  constructor(
    private http: Http,
    protected configService: ConfigService,
    protected injector: Injector,
    protected nbdummy: NbDummyAuthProvider,
    //protected tokenService: NbTokenService,
    // @Optional() @Inject(NB_AUTH_PROVIDERS_TOKEN) protected providers = {},
    ) {
      this.baseUrl = configService.getApiURI();
/*
     this.providers =
       {
            email: {
              service: NbDummyAuthProvider,
              config: {
                delay: 3000,
                login: {
                  rememberMe: true,
                },
              },
            },
        };
*/

  }

  /**
   * Retrieves current authenticated token stored
   * @returns {Observable<any>}
   */
  getToken(): Observable<NbAuthSimpleToken> {
    return observableOf(new NbAuthSimpleToken());
    //return this.tokenService.get();

    //return this.tokenService.get();
  }

  /**
   * Returns true if auth token is presented in the token storage
   * // TODO: check exp date for JWT token
   * @returns {Observable<any>}
   */
  isAuthenticated(): Observable<any> {
    return this.getToken().pipe(map(token => !!(token && token.getValue())));
  }

  /**
   * Returns tokens stream
   * @returns {Observable<any>}
   */
  onTokenChange(): Observable<NbAuthSimpleToken> {
    return observableOf(new NbAuthSimpleToken());
    //return this.tokenService.tokenChange();
  }

  /**
   * Returns authentication status stream
   *  // TODO: check exp date for JWT token
   * @returns {Observable<any>}
   */
  onAuthenticationChange(): Observable<boolean> {
    return this.onTokenChange().pipe(map(token => !!(token && token.getValue())));
  }

  /**
   * Authenticates with the selected provider
   * Stores received token in the token storage
   *
   * Example:
   * authenticate('email', {email: 'email@example.com', password: 'test'})
   *
   * @param provider
   * @param data
   * @returns {Observable<NbAuthResult>}
   */
  authenticate(provider: string, data?: any): Observable<NbAuthResult> {
    return this.authFocus(data);
    //return this.getUserFocus(data);

    //return this.getUserFrotalog(data);
    /*
    //return this.getProvider(provider).authenticate(data)
    //console.info('nbdummy', this.nbdummy);
    return this.nbdummy.authenticate(data)
      .switchMap((result: NbAuthResult) => {


        //window.localStorage.setItem('', user);
        //let user = new User(1, 'admin@crearesistemas.com.br','1234', 'Creare Sistemas Admin');
        let user = new User(1, data.email, data.password, 'Usuario ' + data.email);
        window.localStorage.setItem('currentUser', JSON.stringify(user));

        result = new NbAuthResult(true, this.nbdummy.createSuccessResponse(data), '/', ['Successfully logged in.']);
        return Observable.of(result);
        //return Observable.of(null);
      });
      */
  }

  public authFocus(user: User): Observable<any> {
    const _ws = this.configService.webServices['authLogin'];

    const login = JSON.stringify({
      'login' : user.login,
      'senha': user.password,
    })

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http.post(_ws.url(this.baseUrl), login, {headers: headers}).pipe(
      map((res: Response) => {
        let result: NbAuthResult, _user: User = res.json();

        if (_user) {
          window.localStorage.setItem('currentUser', JSON.stringify(_user));
          result = new NbAuthResult(true, this.nbdummy.createSuccessResponse(login), '/', ['Successfully logged in.']);
        }

        return result
      }),
      catchError(this.handleError),
    );
  }

  public getUserFocus(data?: any): Observable<any> {
    return this.http.get(this.configService.wsServicesUrl('userFocus', data.email)).pipe(
      map((res: Response) => {
        let result: NbAuthResult, _user: User = res.json();

        if (_user) {
          window.localStorage.setItem('currentUser', JSON.stringify(_user));
          result = new NbAuthResult(true, this.nbdummy.createSuccessResponse(data), '/', ['Successfully logged in.']);
        }

        return result
      }),
      catchError(this.handleError),
    );
  }

  private handleError(error: any) {
    const errMsg = error._body;

    if (error.status == 500) {
      const exception: errorMessage = JSON.parse(error._body);
      return observableThrowError(exception.message);
    } else {
      return observableThrowError(errMsg);
    }
  }

  /**
   * Registers with the selected provider
   * Stores received token in the token storage
   *
   * Example:
   * register('email', {email: 'email@example.com', name: 'Some Name', password: 'test'})
   *
   * @param provider
   * @param data
   * @returns {Observable<NbAuthResult>}
   */
  register(provider: string, data?: any): Observable<NbAuthResult> {
    return this.getProvider(provider).register(data).pipe(
      switchMap((result: NbAuthResult) => {


        /*
        if (result.isSuccess() && result.getTokenValue()) {
          return this.tokenService.set(result.getTokenValue())
            .switchMap(_ => this.tokenService.get())
            .map(token => {
              result.replaceToken(token);
              return result;
            });
         }
         */
 result = new NbAuthResult(true, this.nbdummy.createSuccessResponse(data), '/', ['Successfully logged in.']);
        return observableOf(result);
      }));
  }

  /**
   * Sign outs with the selected provider
   * Removes token from the token storage
   *
   * Example:
   * logout('email')
   *
   * @param provider
   * @returns {Observable<NbAuthResult>}
   */
  logout(provider: string): Observable<NbAuthResult> {
    return this.getProvider(provider).logout().pipe(
      tap((result: NbAuthResult) => {
        if (result.isSuccess()) {
          //this.tokenService.clear().subscribe(() => { });
          console.log('Logout Auth.Service');
        }
      }));
  }

  /**
   * Sends forgot password request to the selected provider
   *
   * Example:
   * requestPassword('email', {email: 'email@example.com'})
   *
   * @param provider
   * @param data
   * @returns {Observable<NbAuthResult>}
   */
  requestPassword(provider: string, data?: any): Observable<NbAuthResult> {
    return this.getProvider(provider).requestPassword(data);
  }

  /**
   * Tries to reset password with the selected provider
   *
   * Example:
   * resetPassword('email', {newPassword: 'test'})
   *
   * @param provider
   * @param data
   * @returns {Observable<NbAuthResult>}
   */
  resetPassword(provider: string, data?: any): Observable<NbAuthResult> {
    return this.getProvider(provider).resetPassword(data);
  }

  getProvider(provider: string): NbAbstractAuthProvider {
    //if (!this.providers[provider]) {
    //  throw new TypeError(`Nb auth provider '${provider}' is not registered`);
   // }



    //return this.injector.get(this.providers[provider].service);
    //return NbDummyAuthProvider;
    //return this.nbdummy;
    return null;
  }
}


/**
 *
 * {
                                    "cause": null,
                                    "stackTrace": [{
                                      "methodName": "run",
                                      "fileName": "Thread.java",
                                      "lineNumber": 748,
                                      "className": "java.lang.Thread",
                                      "nativeMethod": false
                                    }],
                                    "errorCode": 0,
                                    "localizedMessage": "O Usuário informado está vinculado a uma Filial que não existe no Focus.",
                                    "message": "O Usuário informado está vinculado a uma Filial que não existe no Focus.",
                                    "suppressed": []
                                  }
 *
 */
